import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { IconModule } from '@insolution/core-data-access';

@Component({
  selector: 'lib-no-search-results',
  imports: [TranslatePipe, IconModule],
  templateUrl: './no-search-results.html',
  styleUrl: './no-search-results.scss',
})
export class NoSearchResults {
  public searchTerm = input.required<string>();
  public noResultsMessage = input<string>('search.no-results-for-search-terms');
}
